import { useQuery } from '@apollo/client'

import { ADVERTISED_PROMOTIONS_QUERY } from '../../../../graphql/promotion'
import { AdvertisedPromotion } from '../../../../types/promotion'

/**
 * The offers this cart is eligible for.
 *
 * `errorPolicy: 'all'` is load-bearing rather than incidental. A failed or partially failed
 * lookup must not block the code field: a booker who knows their code can still use it, and
 * the list is an aid rather than the mechanism. Same policy as the panel's.
 *
 * Always returns an array, so no caller has to decide what an absent list means.
 */
export function useAdvertisedOffers(cartID: string): {
  offers: AdvertisedPromotion[]
  loading: boolean
} {
  const { data, loading } = useQuery<{
    advertisedPromotions: AdvertisedPromotion[]
  }>(ADVERTISED_PROMOTIONS_QUERY, {
    variables: { cartID },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all'
  })

  return { offers: data?.advertisedPromotions ?? [], loading }
}
